import { axiosInstance } from "./axiosInstance";



export async function getFolders()
{
  return axiosInstance.post("/protocol/folders")
    .then(resJson =>
    {
      const data = resJson.data as { folders: {
        folderId: number,
        parentFolderId?: number,
        name: string }[] } | null | undefined;
      return data?.folders;
    })
    .catch(error => console.log("Error retrieving folders:", error));
}

export async function postFolder(name: string, parentFolderId?: number)
{
  return axiosInstance.post("/protocol/newFolder", { name, parentFolderId })
    .then(resJson =>
    {
      const data = resJson.data as { folderId: number } | null | undefined;
      return data?.folderId;
    })
    .catch(error => console.log("Error creating new folder:", error));
}

export async function postProtocolFolder(protocolId: number, folderId?: number)
{
  return axiosInstance.post("/protocol/updateProtocolFolder", { protocolId, folderId })
    .catch(error => console.log("Error updating protocol folder:", error));
}

export async function postFolderParent(folderId: number, parentFolderId?: number)
{
  return axiosInstance.post("/protocol/updateFolderParent", { folderId, parentFolderId })
    .catch(error => console.log("Error updating folder parent:", error));
}

export async function deleteFolder(folderId: number)
{
  return axiosInstance.post("/protocol/deleteFolder", { folderId })
    .catch(error => console.log("Error creating new folder:", error));
}

export async function postFolderName(folderId: number, name: string)
{
  return axiosInstance.post("/protocol/renameFolder", { folderId, name })
    .catch(error => console.log("Error sending folder name:", error));
}